import { useEffect, useState } from "react";
import {
  ChartDataParams,
  FormatChartData,
  ProcessChartData,
} from "../../../components/recharts/functions";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { ChartType } from "../../../models/chart_model";
import { ExchangeColors } from "../Exchange3/FormatData";
import { renderQuarterTick } from "../../../components/recharts/components";
import FilterMenu from "../../../components/FilterMenu";
import { LNGImportData } from "../../../models/gas";
import { getGasLNGImportData } from "../../../Rest_api/RestApi";
import {
  getFiscalYear,
  GetNumberOfDaysInMonth,
  getQuarter,
} from "../../../extensions/date";
import { stringToConsistentColor } from "../../../extensions/string";
import {
  GAS_BAR_GAP,
  getAvailableMonths,
  getGasColors,
  INTERVALS,
} from "./Gas_Const";
import { Label } from "recharts";
import { SearchBox } from "../../../components/Search";

const GROUP_BY = [
  { key: "sector__sector_name", label: "Sector" },
  { key: "sector__sector_type__sector_type", label: "Sector Type" },
];
const keys = [
  {
    key: "month",
    label: "Month",
  },
];
const units = [
  { value: "mmt", label: "MMT" },
  { value: "mmscm", label: "MMSCM" },
  { value: "million_usd", label: "Million USD" },
  { value: "rs_crore", label: "Crore Rs" },
];

const volume_units = [
  { value: "mmt", label: "MMT" },
  { value: "mmscm", label: "MMSCM" },
  { value: "mmscmd", label: "MMSCMD" },
];
const price_units = [
  { value: "usd_mbtu", label: "USD/MBTU" },
  { value: "inr_mbtu", label: "INR/MBTU" },
  { value: "rs_mmscm", label: "INR Cr/MMSCM" },
  { value: "usd_mmscm", label: "Million USD/MMSCM" },
  { value: "million_usd", label: "Million USD" },
  { value: "rs_crore", label: "Crore Rs" },
];
export function GasImport() {
  const [importData, setimportData] = useState<LNGImportData[]>([]);
  const [selectedVolumeUnit, setSelectedVolumeUnit] = useState(volume_units[2]);
  const [selectedPriceUnit, setSelectedPriceUnit] = useState(price_units[1]);
  const [availableMonths, setAvailableMonths] = useState<any[]>([]);
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState<any[]>([]);
  const [selectedGroupKeys, setSelectedGroupKeys] = useState<any[]>([
    GROUP_BY[1],
  ]);
  const [selectedKeys, setSelectedKeys] = useState<any[]>(keys);
  useEffect(() => {
    _handlefetchData();
  }, []);
  useEffect(() => {
    let filteredData = importData;
    if (selectedKeys.length == 1) {
      const unique_month_year = filteredData
        .map((item) => item.month_year)
        .filter((value, index, self) => self.indexOf(value) === index);
      if (selectedKeys[0].key == "year") {
        filteredData = filteredData.map((item) => {
          const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_year.filter((month_year) =>
            month_year.includes(item.year.toString())
          ).length;
          return {
            ...item,
            mmscmd: item.mmscmd / monthsInYear,
            inr_mbtu: item.inr_mbtu / monthsInYear,
            rs_mmscm: item.rs_mmscm / monthsInYear,
            usd_mbtu: item.usd_mbtu / monthsInYear,
            usd_mmscm: item.usd_mmscm / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "month") {
        filteredData = filteredData.map((item) => {
          const number_of_month = unique_month_year.filter((month_year) =>
            month_year.includes(item.month)
          ).length;
          return {
            ...item,
            mmscmd: item.mmscmd /*/ number_of_month */,
            mmt: item.mmt /*/ number_of_month */,
            mmscm: item.mmscm /*/ number_of_month */,

            million_usd: item.million_usd /*/ number_of_month */,
            rs_crore: item.rs_crore /*/ number_of_month */,
            inr_mbtu: item.inr_mbtu /*/ number_of_month */,
            usd_mbtu: item.usd_mbtu /*/ number_of_month */,
          };
        });
      } else if (selectedKeys[0].key == "fyear") {
        const unique_month_fyear = filteredData
          .map((item) => item.month_fyear)
          .filter((value, index, self) => self.indexOf(value) === index);
        filteredData = filteredData.map((item) => {
          // const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_fyear.filter((month_year) =>
            month_year.includes(item.fyear.toString())
          ).length;
          return {
            ...item,
            mmscmd: item.mmscmd / monthsInYear,

            rs_mmscm: item.rs_mmscm / monthsInYear,

            inr_mbtu: item.inr_mbtu / monthsInYear,
            usd_mbtu: item.usd_mbtu / monthsInYear,
            usd_mmscm: item.usd_mmscm / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "quarter") {
        const unique_month_quarter = filteredData
          .map((item) => item.month_quarter)
          .filter((value, index, self) => self.indexOf(value) === index);
        filteredData = filteredData.map((item) => {
          const monthsInYear = unique_month_quarter.filter((month_year) =>
            month_year.includes(item.quarter.toString())
          ).length;
          return {
            ...item,
            mmscmd: item.mmscmd / monthsInYear,

            inr_mbtu: item.inr_mbtu / monthsInYear,
            usd_mbtu: item.usd_mbtu / monthsInYear,
          };
        });
      }
    }

    const par: ChartDataParams = {
      keys: selectedKeys.map((item) => item.key),
      groupBy: [],
      volumeKey: "mmt",
      priceKey: "",
      aggregationKeys: [
        "mmscm",
        "inr_mbtu",
        "million_usd",
        "usd_mbtu",
        "rs_crore",
        "mmscmd",
        "rs_mmscm",
        "usd_mmscm",
      ],
      data: filteredData,
    };
    const data = ProcessChartData(par as any);
    console.log(data);

    setChartData(data.data);
    setChartKeys(data.keys);
  }, [importData, selectedGroupKeys, selectedKeys]);

  function _handleGroupByChange(index: number) {
    setSelectedGroupKeys([GROUP_BY[index]]);
  }
  const handleKeySelection = (keyIndex: number) => {
    const selectedKey = INTERVALS[keyIndex]; // The key to be toggled

    // const isSelected = selectedKeys.find(

    setSelectedKeys([selectedKey]);
  };

  async function _handlefetchData() {
    const newData = await getGasLNGImportData({});
    setimportData(newData);
    setAvailableMonths(getAvailableMonths(newData));
  }
  return (
    <div className="gas-page-container">
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="Interval"
          items={INTERVALS.map((item) => item.label)}
          selectedItems={selectedKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            handleKeySelection(index);
          }}
        />
        <FilterMenu
          title="Volume Unit"
          items={volume_units.map((item) => item.label)}
          selectedItems={[selectedVolumeUnit.label]}
          onSelect={(item, index) => {
            setSelectedVolumeUnit(volume_units[index]);
          }}
        />
        <FilterMenu
          title="Price Unit"
          items={price_units.map((item) => item.label)}
          selectedItems={[selectedPriceUnit.label]}
          onSelect={(item, index) => {
            setSelectedPriceUnit(price_units[index]);
          }}
        />
      </div>
      <div className="gas-chart-container">
        <div className="gas-heading">
          <h2 className="chartHeading">
            Volume ({selectedVolumeUnit.label}) and Price (
            {selectedPriceUnit.label})
          </h2>
          <SearchBox
            options={availableMonths}
            isMany={true}
            placeholder={
              availableMonths.length > 0
                ? `${availableMonths[0].label} to ${
                    availableMonths[availableMonths.length - 1].label
                  }`
                : "Select a date range"
            }
            selectedOptions={selectedMonthYear}
            onChange={(selected: any) => {
              setSelectedMonthYear(selected);
            }}
          />
        </div>

        <ReMixChart
          data={chartData}
          chartContainerHeight="100vh"
          unit=""
          yAxisLabel={`Volume (${selectedVolumeUnit.label})`}
          secondYAxisLabel={`Price (${selectedPriceUnit.label})`}
          secondYAxisWidth={50}
          barCategoryGap={GAS_BAR_GAP}
          xTick={true}
          legends={[
            // ] //     }).flat() //         } //             legendColor: ExchangeColors[index], //             stroke: ExchangeColors[index], //             type: ChartType.Line, //             name: key, //             dataKey: key+'_domestic_consumption', //         return { //     ...chartKeys.map((key, index) => { // [
            {
              dataKey: "_" + selectedVolumeUnit.value,
              name: selectedVolumeUnit.label,
              type: ChartType.Bar,
              stroke: getGasColors("Imported"),
            },
            {
              dataKey: "_" + selectedPriceUnit.value,
              name: selectedPriceUnit.label,
              yAxisId: "right",
              type: ChartType.Line,
              stroke: "#616161", // Darker Gray,
            },

            // ...units
            //   .map((item, index) => {
            //     return chartKeys.map((key, index2) => {
            //       return {
            //         dataKey: key + "_" + item.value,
            //         name: item.label,
            //         type: ChartType.Line,
            //         stroke: ExchangeColors[index],
            //         legendColor: ExchangeColors[index],
            //       };
            //     });
            //   })
            //   .flat(),
          ]}
          xDataKey={selectedKeys[0].key}
          secondXDataKey={
            selectedKeys.length > 1 ? selectedKeys[1].key : undefined
          }
          rendexSecondXTick={(value: any) => renderQuarterTick(value, 8)}
        />
      </div>
    </div>
  );
}
